import { IconProps } from './IconProps';
export function VideoPlayerIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.947 15.7756C9.79458 15.8518 9.62523 15.8877 9.45501 15.8801C9.28479 15.8724 9.11935 15.8214 8.97439 15.7318C8.82944 15.6423 8.70977 15.5172 8.62674 15.3684C8.54372 15.2196 8.50009 15.052 8.5 14.8816V9.11763C8.50009 8.94724 8.54372 8.7797 8.62674 8.6309C8.70977 8.48211 8.82944 8.35699 8.97439 8.26744C9.11935 8.17788 9.28479 8.12684 9.45501 8.11918C9.62523 8.11151 9.79458 8.14747 9.947 8.22363L15.711 11.1056C15.8769 11.1888 16.0164 11.3164 16.1138 11.4743C16.2113 11.6322 16.2629 11.8141 16.2629 11.9996C16.2629 12.1852 16.2113 12.3671 16.1138 12.525C16.0164 12.6828 15.8769 12.8105 15.711 12.8936L9.947 15.7756Z"
                stroke="#66182A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.5 2.5H19.5C19.5 2.5 23.5 2.5 23.5 6.5V17.5C23.5 17.5 23.5 21.5 19.5 21.5H4.5C4.5 21.5 0.5 21.5 0.5 17.5V6.5C0.5 6.5 0.5 2.5 4.5 2.5Z"
                stroke="#66182A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
